export default  {
    //时间戳转日期
    timestampToTime:function(timestamp) {
      var date = new Date(timestamp * 1000)//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-'
      var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-'
      var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' '
      var h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':'
      var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':'
      var s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds())
      return Y+M+D
    },
  
     //时间戳转日期带时分秒
     timestampSfm:function(timestamp) {
      var date = new Date(timestamp * 1000)//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-'
      var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-'
      var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' '
      var h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':'
      var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':'
      var s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds())
      return Y+M+D+h+m+s
    },
  
     //时间戳转日期 月日时分
     timestampNy:function(timestamp) {
      var date = new Date(timestamp * 1000)//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      // var Y = date.getFullYear() + '-'
      var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-'
      var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' '
      var h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':'
      var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) 
      // var s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds())
      return M+D+h+m
    },
  
     //时间戳转日期 年
     timestampN:function(timestamp) {
      var date = new Date(timestamp * 1000)//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() 
      // var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-'
      // var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' '
      // var h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':'
      // var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) 
      // var s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds())
      return Y
    }
  }


// WEBPACK FOOTER //
// ./src/tools/public.js